// extracted by mini-css-extract-plugin
export default {"item":"Sidebar_item__MMp8r","itemInactive":"Sidebar_itemInactive__ynAm4","itemActive":"Sidebar_itemActive__UALjg"};